define([
	"dojo/_base/declare",
	"Apparel/NewProductSourceSamples",
	"./DesignatedSupplierMixin"
], function(declare,NewProductSourceSamples,DesignatedSupplierMixin) {

	return declare([NewProductSourceSamples,DesignatedSupplierMixin], {
	    /**
	     * @override
	     * initialize designated supplier, product and SizeOwner on samples form
	     */
	    onCreatePopup: function(view) {
	        this.initializeDPS(view, "Supplier");
	        var viewNode = this.widget.getViewNode();
	        view.setProduct(viewNode);
	        view.urlSizeOwner = viewNode.ShapeSizeRange;
		}
	});
});
